(function() {
    'use strict';
    function MwMediaListUpdateModal($translate, $element) {
        let descriptionTextArea = null;
        this.$translate = $translate;

        this.dialogTitle = this.$translate.instant('icm-web__list-of-lists--edit-list');

        this.nameInputLabel = this.$translate.instant('icm-web__media-list-modal--name-label');
        this.descriptionInputLabel = this.$translate.instant('icm-web__media-list-modal--list-description-label');

        this.okButtonText = this.$translate.instant('Save');
        this.cancelButtonText = this.$translate.instant('Cancel');

        this.errorMessages = {
            name: {
                required: 'icm-web__media-list-modal--name-required-error',
                maxLengthError: 'icm-web__media-list-modal--name-max-length-error',
                duplicate: 'icm-web__media-list-modal--duplicate-name-error'
            },
            description: {
                maxLengthError: 'icm-web__media-list-modal--description-max-length-error'
            }
        };

        this.duplicateName = '';
        this.setDuplicateNameErrorState = function setDuplicateNameErrorState() {
            this.duplicateName = this.mediaList.name;

            this.mediaListForm.mediaListName.$error['duplicate-name'] = true;
            this.mediaListForm.mediaListName.$invalid = true;
        };
        this.clearDuplicateNameErrorState = function clearDuplicateNameErrorState() {
            if(this.mediaListForm && this.mediaListForm.mediaListName && this.mediaListForm.mediaListName.$error['duplicate-name']) {
                delete this.mediaListForm.mediaListName.$error['duplicate-name'];

                if(Object.keys(this.mediaListForm.mediaListName.$error).length === 0) {
                    this.mediaListForm.mediaListName.$invalid = false;
                }
            }
        };

        this.$postLink = function postLink() {
            descriptionTextArea = $element.find('.media-list-description textarea');

            if(descriptionTextArea) {
                descriptionTextArea.on('keypress', function(event) {
                    // prevent user from entering newlines into textarea
                    if (event.keyCode === 13) {
                        event.preventDefault();
                    }
                });
            }
        };

        this.$onDestroy = function onDestroy() {
            if(descriptionTextArea) {
                descriptionTextArea.off('keypress');
            }
        };

        // watch for changes to the bindings.
        // this is here to capture certain server side errors that we wish to display in the modal.
        this.$onChanges = function onBindingChanges(changes) {
            if(changes.duplicateError) {
                if(changes.duplicateError.currentValue === true) {
                    this.setDuplicateNameErrorState();
                } else {
                    this.clearDuplicateNameErrorState();
                }
            }
        };

        // watch the media list name for changes.
        // we want to do this to manually set/reset server side errors we may have manually set.
        this.onNameChange = function onNameChange() {
            if(this.duplicateError && (this.mediaList.name !== this.duplicateName)) {
                this.duplicateError = false;
                this.clearDuplicateNameErrorState();
            } else if(this.mediaList.name === this.duplicateName) {
                this.duplicateError = true;
                this.setDuplicateNameErrorState();
            }
        };

        // --------------
        // Modal Actions
        // --------------
        this.cancelModal = function cancelModal() {
            this.cancelCallback();
        };

        this.okModal = function okModal() {
            if (this.mediaListForm.$valid && !this.mediaListForm.mediaListName.$invalid) {
                this.okCallback({updatedMediaList: this.mediaList});
            }
        };
    }

    angular
        .module('MW.ContactManager.MwMediaListUpdateModal', [])
        .component('mwMediaListUpdateModal', {
            bindings: {
                cancelCallback: '&',
                okCallback: '&',
                mediaList: '<',
                duplicateError: '<'
            },
            controller: ['$translate', '$element', MwMediaListUpdateModal],
            template: `
                <mw-mini-modal-dialog layout="column" dialog-title="{{$ctrl.dialogTitle}}" ok="{{$ctrl.okButtonText}}" cancel="{{$ctrl.cancelButtonText}}" on-ok="$ctrl.okModal()" on-cancel="$ctrl.cancelModal()">
                    <mw-modal-content>
                        <ng-form name="$ctrl.mediaListForm">
                            <div layout="column">
                                <md-input-container class="media-list-name" md-is-error="$ctrl.mediaListForm.mediaListName.$invalid">
                                    <label>{{$ctrl.nameInputLabel}}</label>
                                    <input required="" name="mediaListName" md-autofocus="true" ng-model="$ctrl.mediaList.name" ng-change="$ctrl.onNameChange()" md-maxlength="190"/>
                                    <div ng-messages="$ctrl.mediaListForm.mediaListName.$error">
                                        <div ng-message="required" translate>{{$ctrl.errorMessages.name.required}}</div>
                                        <div ng-message="md-maxlength" translate>{{$ctrl.errorMessages.name.maxLengthError}}</div>
                                        <div ng-message="duplicate-name" translate>{{$ctrl.errorMessages.name.duplicate}}</div>
                                    </div>
                                </md-input-container>
                                <md-input-container class="media-list-description" md-is-error="$ctrl.mediaListForm.mediaListDescription.$invalid">
                                    <label>{{$ctrl.descriptionInputLabel}}</label>
                                    <textarea name="mediaListDescription" md-autofocus="false" ng-model="$ctrl.mediaList.description" md-maxlength="150" rows="1" wrap="soft"/>
                                    <div ng-messages="$ctrl.mediaListForm.mediaListDescription.$error">
                                        <div ng-message="md-maxlength" translate>{{$ctrl.errorMessages.description.maxLengthError}}</div>
                                    </div>
                                </md-input-container>
                            </div>
                        </ng-form>
                    </mw-modal-content>
                </mw-mini-modal-dialog>
            `
        });
}());
